// src/pages/talleres/editar/constants.js

export const TIPOS_ACTIVIDAD = [
  { label: 'Actividad Física y Salud (AFS)', value: 'Actividad Física y Salud (AFS)' },
  { label: 'Academias Deportivas (AD)', value: 'Academias Deportivas (AD)' },
  { label: 'Escuelas Deportivas (ED)', value: 'Escuelas Deportivas (ED)' },
  { label: 'Escuelas Abiertas (EA)', value: 'Escuelas Abiertas (EA)' },
  { label: 'Deporte Vecinal (DVEC)', value: 'Deporte Vecinal (DVEC)' },
  { label: 'Personas Mayores (PM)', value: 'Personas Mayores (PM)' },
  { label: 'Fútbol (FUT)', value: 'Fútbol (FUT)' },
  { label: 'Juegos Deportivos Escolares (JDE)', value: 'Juegos Deportivos Escolares (JDE)' },
  { label: 'Kinesiología (KINE)', value: 'Kinesiología (KINE)' },
  { label: 'Bienestar (BIE)', value: 'Bienestar (BIE)' },
  { label: 'Asistencia a las OODD (OODD)', value: 'Asistencia a las OODD (OODD)' },
  { label: 'Intersectorialidad (INT)', value: 'Intersectorialidad (INT)' },
  { label: 'Proyectos (PRO)', value: 'Proyectos (PRO)' },
  { label: 'Sistema de Apoyo a Deportistas (SAD)', value: 'Sistema de Apoyo a Deportistas (SAD)' },
  { label: 'Eventos (EV)', value: 'Eventos (EV)' },
];

export const DIAS_OPTIONS = [
  { label: 'Lunes', value: 'lunes' },
  { label: 'Martes', value: 'martes' },
  { label: 'Miércoles', value: 'miércoles' },
  { label: 'Jueves', value: 'jueves' },
  { label: 'Viernes', value: 'viernes' },
  { label: 'Sábado', value: 'sábado' },
  { label: 'Domingo', value: 'domingo' },
];

export const PLANES = [
  { label: "Mensual", value: "mensual" },
  { label: "Trimestral", value: "trimestral" },
  { label: "Semestral", value: "semestral" },
  { label: "Anual", value: "anual" },
];

export const CAMPOS_VALORES_EXT = [
  { key: "valorParticular", label: "Valor particular", required: true },
  { key: "valorVecino", label: "Valor vecino", required: false },
  { key: "valorAdultoMayor", label: "Valor adulto mayor", required: false },
  { key: "valorFuncionarios", label: "Valor funcionarios", required: false },
  { key: "matricula", label: "Matrícula", required: false },
];

export const TIPO_DURACION_OPTIONS = [
  {
    label: '📅 Mes calendario (día a día)',
    value: 'mes_calendario',
  },
  {
    label: '📆 Fin de mes',
    value: 'fin_de_mes',
  },
  {
    label: '📆 Mes corrido (30 días)',
    value: 'mes_corrido',
  },
];

export const diasOrder = ["lunes", "martes", "miércoles", "jueves", "viernes", "sábado", "domingo"];

/**
 * Índices de los pasos del wizard de creación.
 *
 * Estaban esparcidos como números sueltos (`setCurrentStep(5)`) en cinco lugares,
 * de modo que mover un paso obligaba a cazarlos uno por uno. Con nombres, el
 * flujo se lee y se reordena sin adivinar.
 *
 * CONFIRMACION y APROBACION no son pasos: son las pantallas de resultado que se
 * muestran una vez que el taller YA se creó. Por eso quedan fuera de STEPS —
 * incluirlas hacía que la tarea pareciera el doble de larga de lo que es.
 */
export const PASO = {
  TALLER: 0,
  FECHAS_Y_PAGOS: 1,
  REVISION: 2,
  HORARIOS: 3,
  CONFIRMACION: 4,
  APROBACION: 5,
};

/** Último paso que se dibuja en el <Steps>; más allá son pantallas de resultado. */
export const ULTIMO_PASO_VISIBLE = PASO.HORARIOS;

/**
 * Pasos del wizard de CREACIÓN de taller.
 *
 * Deben coincidir uno a uno con PASO.TALLER … PASO.HORARIOS.
 *
 * "Fechas" y "Pagos" iban separados pese a ser 3 y 2 campos respectivamente: dos
 * pantallas casi vacías que alargaban el recorrido sin agrupar nada distinto.
 * Ahora van juntas bajo "Fechas y pagos", que es una sola decisión: cuándo se
 * dicta el taller y cuánto cuesta.
 *
 * (El wizard de edición tiene su propia lista en ../Edit/constants.js, que
 * termina en "Resumen" porque no crea horarios ni pasa por aprobación.)
 */
export const STEPS = [
  { title: "Taller", key: "taller" },
  { title: "Fechas y pagos", key: "fechas-pagos" },
  { title: "Revisión", key: "revision" },
  { title: "Horarios", key: "horarios" },
];

/**
 * Frase de apoyo bajo el título de la página, según el paso.
 *
 * Va aparte de STEPS —y no como `description` de cada item— para que el stepper
 * no crezca: el texto solo hace falta para el paso en el que se está.
 */
export const AYUDA_PASO = [
  "Qué se dicta, dónde y para quién.",
  "Cuándo se dicta y cuánto cuesta.",
  "Revisa los datos antes de crear el taller.",
  "Agrega los horarios. También puedes hacerlo más tarde.",
];

export const INITIAL_VALUES = {
  esGratuito: false,
  liberarCuposPorBaja: true,
  tipoDuracionSuscripcion: 'mes_corrido'
};
